/**
 * The heading above each Progress section.
 *
 * Its own file rather than an export from `ProgressLayout`, which is where it
 * used to live: `ProgressLayout` imports `InsightsSection`, so having
 * `InsightsSection` import the label back from it would close an import cycle.
 *
 * Worth a component at all because `InsightsSection` had written the identical
 * `h2` out three times — once per branch (loading, empty, loaded) — while
 * `ProgressLayout` had a fourth copy behind this name.
 */
export function SectionLabel({ children }: { children: React.ReactNode }) {
  return (
    <h2 className='text-base font-semibold text-foreground'>{children}</h2>
  );
}
